module.exports = __webpack_public_path__ + "static/media/CUNARD.4851c310.png";